import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { withRouter } from "react-router-dom";
import _ from 'lodash';

import { changeProject } from '../../actions/projects';

class ProjectsMenu extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  componentDidUpdate() {
    const { selected_project, history } = this.props;
    if (selected_project) {
      history.push("/dashboard");
    }
  }

  changeProject(project) {
    const { changeProject, history } = this.props;
    changeProject(project);
  }

  viewAllProject() {
    document.body.classList.remove('sidebar-lg-show');
    const { changeProject, history } = this.props;
    changeProject(null);
    history.push("/projects");
  }

  render() {
    const { selected_project, projects } = this.props;
    let sub_projects = _.filter(projects, { 'status': 'ACTIVE', 'projectType': 'MANAGED' });
    sub_projects = _.orderBy(sub_projects, ['updatedDate'], ['desc']);
    sub_projects = _.slice(sub_projects, 0, 10);
    return (
      <Dropdown setActiveFromChild isOpen={this.state.dropdownOpen} toggle={() => {
        this.toggle();
      }}>
        <DropdownToggle style={{ width: 250 }} className="bg-light d-flex align-items-center justify-content-between">
          <span>
            {selected_project ? selected_project.name : "Select a Project"}
          </span> <i className="fa fa-sort-down"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg">
          <DropdownItem onClick={() => this.viewAllProject()}><i className="fa fa-folder-o"></i> View All Projects</DropdownItem>
          <DropdownItem header>Recent Projects</DropdownItem>
          {
            sub_projects.map((project) => {
              return <DropdownItem key={project._id} onClick={() => this.changeProject(project)} className="d-flex align-items-center justify-content-between"><span>{project.name}</span> <small className="text-muted">#{project.id}</small></DropdownItem>
            })
          }
        </DropdownMenu>
      </Dropdown>
    );
  }
}

function mapStateToProps({ projects, selected_project }) {
  return {
    projects, selected_project
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeProject
  }, dispatch);
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectsMenu));



// WEBPACK FOOTER //
// ./src/containers/menus/ProjectsMenu.js